import { Card, Stack, Typography, Box } from '@mui/material';
import React from 'react';
import PieChart from '../../../Components/Charts/PieChart';
import DataNotFound from '../../../Components/DataNotFound';

const PieGraphCard = ({ data, colors, extraLables ,title, isDoughnut = false }) => {

    const allZero = Object.values(data).every(v => v === 0);
    const pieChartData = {
        labels: Object.keys(data),
        datasets: [
            {
                data: Object.values(data) ,
                backgroundColor: colors,
                borderColor: '#ffffff',
                borderWidth: 0,
            },
        ],
    };

    // Create custom legend data
    const legendData = Object.keys(data).map((key, index) => ({
        label: extraLables[index],
        value: data[key],
        color: colors[index]
    }));

    return (
        <Card sx={{ minHeight: '100%', p: 2 }}>
            {/* Header */}
            <Stack mb={!allZero ? 10 : 5} direction="row" width={'100%'}>
                <Typography  fontSize={14} fontWeight={600} lineHeight={'150%'}>
                    {title}
                </Typography>
            </Stack>
            
            {/* Chart and Legend Container */}
            {!allZero ? <Stack direction="row" alignItems="center" spacing={2}>
                {/* Left side - Pie Chart (50% width) */}
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                    <PieChart 
                        data={pieChartData} 
                        width={165} 
                        height={165} 
                        isDoughnut={isDoughnut}
                        options={{
                            plugins: {
                                legend: {
                                    display: false, // Hide default legend
                                }
                            }
                        }}
                    />
                </Box>
                
                {/* Right side - Custom Legend (50% width) */}
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                    <Stack spacing={2.5} alignItems="flex-start">
                        {legendData.map((item, index) => (
                            <Stack key={index} direction="row" alignItems="center" spacing={1.5}>
                                {/* Colored dot */}
                                <Box
                                    sx={{
                                        width: 12,
                                        height: 12,
                                        borderRadius: '50%',
                                        backgroundColor: item.color,
                                        flexShrink: 0,
                                    }}
                                />
                                {/* Label and count in same row */}
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Typography 
                                        variant="body2" 
                                        fontFamily={'Poppins'} 
                                        fontSize={14} 
                                        fontWeight={500}
                                        noWrap
                                    >
                                        {item.label}
                                    </Typography>
                                    <Typography 
                                        variant="body2" 
                                        fontFamily={'Poppins'} 
                                        fontSize={14} 
                                        fontWeight={700}
                                        color={item.color} // Same color as the dot
                                    >
                                        {item.value}
                                    </Typography>
                                </Stack>
                            </Stack>
                        ))}
                    </Stack>
                </Box>
            </Stack> : <Stack sx={{ display: 'flex' }} alignItems="center" justifyContent="center" height="100%" width="100%">
                <DataNotFound size={150} />
            </Stack>}
        </Card>
    );
};

export default PieGraphCard;